import { apiClient } from "lib/axios";

const normalizeRefund = (refund) => {
  if (!refund) return refund;

  return {
    ...refund,
    id: refund.id || refund._id,
    clientId:
      refund.clientId?._id ||
      refund.clientId?.id ||
      refund.clientId ||
      refund.client?._id ||
      refund.client?.id ||
      "",
    clientName:
      refund.clientName || refund.clientId?.name || refund.client?.name || "—",
    date: refund.refundDate || refund.date,
    refundMode: refund.paymentMode || refund.refundMode,
    paidFrom: refund.refundFrom || refund.paidFrom,
    comments: refund.reason || refund.comments,
  };
};

const normalizeRefundListResponse = (data) => {
  const refunds = data?.refunds || data?.data?.refunds || data?.data || [];

  return {
    ...data,
    refunds: Array.isArray(refunds) ? refunds.map(normalizeRefund) : [],
  };
};

const normalizeRefundResponse = (data) => {
  const refund = data?.refund || data?.data?.refund || data?.data || data;

  return {
    ...data,
    refund: normalizeRefund(refund),
  };
};

const buildCleanPayload = (payload) => ({
  clientId: payload.clientId,
  branchId: payload.branchId || null,
  refundDate: payload.refundDate || payload.date,
  amount: payload.amount,
  paymentMode: payload.paymentMode || payload.refundMode,
  refundFrom: payload.refundFrom || payload.paidFrom || null,
  reference: payload.reference || null,
  reason: payload.reason || payload.comments || null,
});

export const getRefunds = async (params = {}) => {
  const { data } = await apiClient.get("/refunds", { params });
  return normalizeRefundListResponse(data);
};

export const getRefundById = async (id) => {
  const { data } = await apiClient.get(`/refunds/${id}`);
  return normalizeRefundResponse(data);
};

export const createRefund = async (payload) => {
  const { data } = await apiClient.post("/refunds", buildCleanPayload(payload));
  return normalizeRefundResponse(data);
};

export const voidRefund = async (id, body = {}) => {
  const { data } = await apiClient.post(`/refunds/${id}/void`, body);
  return normalizeRefundResponse(data);
};
